module.exports = __webpack_public_path__ + "static/media/portfolio1 (41).e3dfcf7d.jpeg";